const metaTramitacoes = { rules: ['TRAMITACOES-JURIDICAS-00'] };

const routes = [
    {
        path: 'tramitacoes-juridicas',
        name: 'SolicitacoesServicos_TramitacoesJuridicas_Listagem',
        component: () => import('./Listagem.vue'),
        meta: metaTramitacoes,
    },
    {
        path: 'tramitacoes-juridicas/inserir',
        name: 'SolicitacoesServicos_TramitacoesJuridicas_Inserir',
        component: () => import('./Inserir.vue'),
        meta: metaTramitacoes,
    },
    {
        path: 'tramitacoes-juridicas/:id',
        name: 'SolicitacoesServicos_TramitacoesJuridicas_Detalhar',
        component: () => import('./Detalhar.vue'),
        meta: metaTramitacoes,
    },
];

export default routes;
